// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._1hmsglyw{text-decoration-line:none}\n._4bfu1r31{text-decoration-color:currentColor}\n._ajmmnqa1{text-decoration-style:solid}\n._syaz131l{color:var(--ds-text-subtlest,#626f86)}._1bnxglyw:hover{text-decoration-line:none}\n._30l3131l:hover{color:var(--ds-text-subtlest,#626f86)}\n._9oik1r31:hover{text-decoration-color:currentColor}\n._jf4cnqa1:hover{text-decoration-style:solid}", ""]);
// Exports
module.exports = exports;
